import montaDocumento from './montaDocumento';
import mesclaAnexosENumera from './mesclaAnexos';
import { dataHora } from './formatadores';
import brasao from '../../../../../assets/logotipo_doc_novo.png';

/**
 * Gera o PDF do relatório de abordagem e devolve o Blob.
 *
 * O pdfmake (1,4 MB + fontes) entra por import dinâmico: só quem abre esta tela
 * paga o download, o bundle inicial do sistema não engorda.
 */

// carrega o asset (URL do webpack) e devolve dataURL — forma confiável de
// entregar imagem ao pdfmake no navegador. Falhou? segue sem o brasão.
const paraDataURL = src =>
  new Promise(resolve => {
    try {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        try {
          const canvas = document.createElement('canvas');
          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;
          canvas.getContext('2d').drawImage(img, 0, 0);
          resolve(canvas.toDataURL('image/png'));
        } catch (erro) {
          resolve(null);
        }
      };
      img.onerror = () => resolve(null);
      img.src = src;
    } catch (erro) {
      resolve(null);
    }
  });

const carregaPdfMake = async () => {
  const [modulo, fontes] = await Promise.all([
    import('pdfmake/build/pdfmake'),
    import('pdfmake/build/vfs_fonts'),
  ]);
  const pdfMake = modulo.default || modulo;
  const vfs = (fontes.pdfMake && fontes.pdfMake.vfs) || (fontes.default && fontes.default.pdfMake.vfs);
  pdfMake.vfs = vfs;
  return pdfMake;
};

const paraBytes = (pdfMake, doc) =>
  new Promise((resolve, reject) => {
    try {
      pdfMake.createPdf(doc).getBuffer(resolve);
    } catch (erro) {
      reject(erro);
    }
  });

export default async function gerarPdfAbordagem(dados, opcoes = {}) {
  const [pdfMake, brasaoDataURL] = await Promise.all([carregaPdfMake(), paraDataURL(brasao)]);

  const doc = montaDocumento(dados, {
    brasao: brasaoDataURL,
    emitidoEm: dataHora(opcoes.emitidoEm || new Date().toISOString()),
    emitidoPor: opcoes.emitidoPor || '',
  });

  const bytes = await paraBytes(pdfMake, doc);
  const anexosPdf = (dados.anexos || []).filter(anexo => anexo.tipo === 'pdf');
  const finais = await mesclaAnexosENumera(bytes, anexosPdf, { abordagemId: dados.abordagem.id });

  return new Blob([finais], { type: 'application/pdf' });
}

export const nomeDoArquivo = abordagemId => `relatorio-abordagem-${abordagemId}.pdf`;
